var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("PageHeading", {
        attrs: {
          text: "Действия",
          mode: "grid",
          "grid-data-loading": _vm.gridDataLoading,
          "results-count": _vm.resultsCount,
        },
      }),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c("GridActionsDictionary", {
                ref: "grid",
                on: {
                  "open-item": function ($event) {
                    _vm.chosenActionItem = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.chosenActionItem !== null
        ? _c("ActionItemDialog", {
            attrs: { item: _vm.chosenActionItem },
            on: {
              close: function ($event) {
                _vm.chosenActionItem = null
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }